import React, { forwardRef } from 'react';

import type { Option } from '@vlabs/monokit/shared/ui/options-filter';
import type { FilterPopoverProps } from '@vlabs/monokit/shared/ui/popovers/filter-popover';
import { FilterPopover } from '@vlabs/monokit/shared/ui/popovers/filter-popover';
import { Control } from '@vlabs/uikit';
import { useFormContext } from 'react-hook-form';

import { useSearchApi } from '../../../../api/SearchApiProvider';
import { useApiData } from '../../../../api/useApiData';
import st from '../popovers.module.sass';

function ListsFilterPopover(
  {
    name = 'list_id',
    ...props
  }: FilterPopoverProps<string>,
  ref: React.ForwardedRef<HTMLDivElement>,
) {
  const { watch, setValue } = useFormContext();
  const api = useSearchApi();
  const { data: listsOptions = [] } = useApiData(api.getListOptions);

  const handleChange = (value: string) => {
    setValue(name, value);
  };

  return (
    <FilterPopover
      {...props}
      name={name}
      ref={ref}
    >
      <div className={st.RadioWrapper}>
        {listsOptions.map((option: Option) => {
          return (
            <Control.Radio
              checked={watch(name) === option.value}
              key={option.value}
              label={option.label}
              onChange={() => handleChange(option.value)}
            />
          );
        })}
      </div>
      <div className={st.Divider} />
    </FilterPopover>
  );
}

const ListsFilterPopoverWithRef = forwardRef(ListsFilterPopover);
export { ListsFilterPopoverWithRef as ListsFilterPopover };
